export const analyticsEvt = {
  editorSaveClick: 'edx.ui.authoring.editor.save',
  editorCancelClick: 'edx.ui.authoring.editor.cancel',
};

export default analyticsEvt;
